/* eslint-disable ember/no-mixins */
import Controller from '@ember/controller';
import EditPostMixin from '@linc-technologies/linced-common/mixins/edit-post';

export default class IndexController extends Controller.extend(EditPostMixin) {}
